<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';

import { default as DefaultMap, isWebGlError } from 'JIX/map/DefaultMap.js';
import ClusteredJobs from 'JIX/map/ClusteredJobs.js';

const props = defineProps({
    geojson: {
        type: Object,
        required: true,
    },
    options: {
        type: Object,
        default: () => ({}),
    },
    clusterOptions: {
        type: Object,
        default: () => ({}),
    },
});

let map;
let clusteredJobs;
const mapEl = ref();
const webglError = ref(false);
onMounted(() => {
    try {
        map = new DefaultMap({
            container: mapEl.value,
            ...props.options
        });
    } catch (error) {
        if (isWebGlError(error)) {
            webglError.value = true;
            return;
        } else {
            throw error;
        }
    }
    if (map) {
        const fitBounds = !props.options.center;
        clusteredJobs = new ClusteredJobs(props.clusterOptions);
        clusteredJobs.addTo(map).setData(props.geojson, fitBounds);
    }
});
onBeforeUnmount(() => map?.remove());

watch(() => props.geojson, () => {
    const fitBounds = !props.options.center;
    clusteredJobs?.setData(props.geojson, fitBounds);
});

</script>

<template>
    <div ref="mapEl">
        <div v-if="webglError" class="text-center bg-surface-1">
            WebGL not supported
        </div>
    </div>
</template>
